// popupRegistry.js
export const popupRegistry = {
	aboutReviews: () => import('@/components/popup/popups/aboutReviews.vue'),
	// Добавить сюда новые попапы по мере необходимости
}
